import Markdown from 'react-markdown';
import postList from '../posts.json';
import { Redirect } from 'react-router-dom';

import './css/Post.css';

const Post = (props) => {
    const validId = parseInt(props.match.params.id);
    if (!validId) {
        console.log('404');
        return <Redirect to="/404" />;
    }
    const fetchedPost = {};
    let postExists = false;

    postList.forEach((post, i) => {
        if (validId === post.id) {
            fetchedPost.name = post.name ? post.name : 'No name found';
            fetchedPost.title = post.title ? post.title : 'No title found';
            fetchedPost.date = post.date ? post.date : 'No date found';
            fetchedPost.content = post.content ? post.content : '';
            fetchedPost.img = post.img ? post.img : 'No image found';
            fetchedPost.ontop = post.ontop ? post.ontop : 'No ontop found';
            fetchedPost.url = post.url ? post.url : 'No URL found';
            fetchedPost.btntext = post.btntext ? post.btntext : 'No btn Text found';
            postExists = true;
        }
    });
    if (!postExists) {
        return <Redirect to="/404" />;
    }
    return (
        <div key={fetchedPost.id} className="body">
            <a href={fetchedPost.url} target={`${fetchedPost.ontop}`} className="btn stretched-link">
                <div className="card h-100" style={{ width: `18rem` }}>
                    {fetchedPost.img !== 'No image found' ? <img src={`${fetchedPost.img}`} alt={fetchedPost.title} className="card-img-top post-img" /> : <div></div>}
                    <div className="card-body">
                        <h4 className="card-title">{fetchedPost.name}</h4>
                        <div className="card-text">
                            <Markdown source={fetchedPost.content} escapeHtml={false} />
                        </div>
                        {/* <a
                        href={fetchedPost.url}
                        target={`${fetchedPost.ontop}`}
                        className='btn btn-primary stretched-link'
                    >
                        {fetchedPost.btntext}
                    </a> */}
                    </div>
                </div>
            </a>
        </div>
    );
};

export default Post;
